import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import NativeApi from '../../utils/nativeApi';
import { defaultTemplate } from '../../utils/styles-constants';
import { StoreState } from '../../reducers';
import { AppInfosState, AppType } from './reducer';
import { MultiAppAuthenticationInfosState, AspConnexionStatus } from '../MultiAppAuthentication/reducer';
import NotificationBar from '../NotificationBar';
import { AppContainer, AppInnerContainer } from './styles';
import { initializeApp } from './actions';
import CookieNotification from '../CookieNotification';
import Gallery from '../Gallery';
import { GalleryInfosState } from '../Gallery/reducer';
import MultiAppAuthentication from '../MultiAppAuthentication';

const svgSpritePath = require('../../images/icons.svg');

export interface AppProps {
	children: React.ReactNode;
	appInfos: AppInfosState;
	multiAppAuthenticationInfos: MultiAppAuthenticationInfosState;
	galleryInfos: GalleryInfosState;
	dispatch: Dispatch<StoreState>;
}

export interface AppState {
	svgSprites: string;
	hasStatusBar: boolean;
}

class App extends React.Component<AppProps, AppState> {

	constructor(props: AppProps) {
		super(props);
		this.state = {
			svgSprites: '',
			hasStatusBar: false
		};
	}

	componentDidMount() {
		if (UserAgentUtils.isMobileApp) {
			this.handleStatusBar();
		}

		this.props.dispatch(initializeApp());

		Utils.promiseXHR('GET', svgSpritePath, undefined, undefined, undefined, undefined, undefined, true)
			.then(response => this.setState({ svgSprites: response.responseText }));
	}

	render() {
		const { children, galleryInfos, appInfos, multiAppAuthenticationInfos } = this.props;
		const { svgSprites, hasStatusBar } = this.state;
		const { template } = galleryInfos;
		const theme = template && template.commonStyles ? template.commonStyles : defaultTemplate.commonStyles;
		const { areCookieAccepted, type } = appInfos;
		const { aspConnexionStatus } = multiAppAuthenticationInfos;
		const isConnectedToAsp = aspConnexionStatus === AspConnexionStatus.SUCCESS;
		const { isMobileApp } = UserAgentUtils;
		const shouldDisplayCookieNotification = !isMobileApp && !areCookieAccepted;
		const shouldDisplayMultiAppAuthentication = isMobileApp && type === AppType.Multiple && !isConnectedToAsp;
		return (
			<ThemeProvider theme={theme}>
				<AppContainer hasStatusBar={hasStatusBar}>
					{type &&
						<AppInnerContainer>
							{shouldDisplayMultiAppAuthentication ?
								<MultiAppAuthentication />
								:
								<Gallery>
									{children}
								</Gallery>
							}
						</AppInnerContainer>
					}
					{!!svgSprites &&
						<div dangerouslySetInnerHTML={{__html: svgSprites}} />
					}
					<NotificationBar />
					<CookieNotification display={shouldDisplayCookieNotification}/>
				</AppContainer>
			</ThemeProvider>
		);
	}

	handleStatusBar = () => {
		setTimeout(() => { this.requestHasStatusBar(); }, 250);
	}

	requestHasStatusBar = () => {
		NativeApi.hasStatusBar()
			.then(hasStatusBar => {
				if (typeof hasStatusBar === 'boolean') {
					this.setState({ hasStatusBar });
				} else {
					this.handleStatusBar();
				}
			})
			.catch(() => this.handleStatusBar());
	}
}

const mapStateToProps = (state: StoreState) => {
	const { appInfos, galleryInfos, multiAppAuthenticationInfos } = state;
	return { appInfos, galleryInfos, multiAppAuthenticationInfos };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/index.tsx